import styled, { css } from '@emotion/native';
import React from 'react';
import { Dimensions } from 'react-native';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import { IsDesktopProps } from '@/shared/styles/types';
import { ButtonSelectItem } from '@/shared/styles/types';
import PreferenceButton from '@/shared/components/PreferenceButton';
import { FORM_MOBILE_PADDING } from '@/shared/styles/styledComponents/editProfileForm';

export interface SelectButtonProps {
  selectedItems: ButtonSelectItem[];
  setSelectedItems: React.Dispatch<React.SetStateAction<ButtonSelectItem[]>>;
  enumArray: ButtonSelectItem[];
}

const GAP = 8;

const SelectButtons = ({
  selectedItems,
  setSelectedItems,
  enumArray,
}: SelectButtonProps) => {
  const isDesktop = useIsDesktop();
  const screenWidth = Dimensions.get('window').width;

  const dynamicMobileButtonWidth =
    (screenWidth - GAP - FORM_MOBILE_PADDING * 2) / 2;

  return (
    <InnerContainer isDesktop={isDesktop}>
      {enumArray.map((item) => (
        <PreferenceButton
          key={item}
          item={item}
          isSelected={selectedItems.includes(item)}
          isDesktop={isDesktop}
          onToggle={() =>
            setSelectedItems((prev: ButtonSelectItem[]) =>
              prev.includes(item)
                ? prev.filter((arrayItem) => arrayItem !== item)
                : [...prev, item],
            )
          }
          buttonStyle={{
            width: isDesktop ? 150 : dynamicMobileButtonWidth,
            height: isDesktop ? 60 : 62,
            marginBottom: 0,
            paddingHorizontal: 18,
          }}
          textStyle={{
            fontSize: isDesktop ? 10 : 14,
          }}
          checkStyle={checkStyle}
        />
      ))}
    </InnerContainer>
  );
};

const InnerContainer = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: GAP,
  alignItems: 'center',
  paddingVertical: isDesktop ? 8 : 8,
  paddingLeft: isDesktop ? 16 : 0,
}));

const checkStyle = css({
  width: 19,
  height: 19,
  position: 'absolute',
  top: 5,
  left: 7,
});

export default SelectButtons;
